module.exports = __webpack_public_path__ + "static/floppy_knights-bf0e30e63be3ccd679c52f3e32421418.png";